module.exports = __webpack_public_path__ + "static/media/radius.469df246.svg";